<div style="display:inline" [id]="this.id" [innerHTML]="this.trustedHtml"></div>
